import styled from 'styled-components';

export const SBankInvestorKey = styled.div`
  color: ${({ theme }) => theme.text.color.light};
  display: inline;
  margin-left: 8px;
`;
